import styled from 'styled-components';
import scaleSize from 'utils/scale-size';

export const StyledListContentWrapper = styled.div.attrs(({ listOffset }) => {
  return {
    style: {
      transform: `translate3d(-${scaleSize(listOffset)}px, 0, 0)`,
    },
  };
})``;

export const StyledListTitle = styled.div`
  height: ${scaleSize(200)}px;
  box-sizing: border-box;
  padding-bottom: ${scaleSize(35)}px;
  padding-top: ${scaleSize(117)}px;
  font-weight: 500;
  font-size: ${scaleSize(40)}px;
  line-height: 1.2;
  letter-spacing: normal;
  color: ${({ theme }) => theme.defaultColor};
  font-family: RobotoMedium, sans-serif;
`;
